var _path, _circle, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertCloud24Px = function SvgAlertCloud24Px(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95406 16.4815L5.80591 16.4815C4.22065 16.4815 2.93554 15.1964 2.93554 13.6111C2.93555 12.0258 4.22065 10.7407 5.80592 10.7407C5.80592 9.15548 7.09102 7.87037 8.67629 7.87037C8.81827 7.87037 8.95784 7.88068 9.09429 7.90059C9.85342 6.19173 11.5655 5 13.5559 5C15.7942 5 17.6806 6.50707 18.2555 8.56184C20.0072 8.99511 21.3059 10.5774 21.3059 12.463C21.3059 14.2834 20.0955 15.8211 18.4355 16.3151",
    stroke: "#606163",
    strokeWidth: 1.14815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6942,
    cy: 15.9074,
    r: 4.16204,
    stroke: "#606163",
    strokeWidth: 0.861111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6943 13.6111L12.6943 16.4815",
    stroke: "#606163",
    strokeWidth: 1.14815,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6942,
    cy: 18.2037,
    r: 0.574074,
    fill: "#606163"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertCloud24Px);
export default ForwardRef;